import React, { useState, useEffect } from 'react';
import './LoginStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import ApiSender from '../common/ApiLogic';

function LoginPage({ updateLoggedIn }) {

  const apiSender = new ApiSender();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    const storedPassword = localStorage.getItem('password');
    if (storedUsername && storedPassword) {
      setUsername(storedUsername);
      setPassword(storedPassword);
      setRememberMe(true);
      handleSavedUsernameFocus();
      handleSavedPasswordFocus();
    }
  }, []);

  const handlePasswordMasking = () => {
    setPasswordVisible(!passwordVisible);
  };
  const handleRememberMe = () => {
    setRememberMe(!rememberMe);
    if (!rememberMe) {
      localStorage.setItem('username', username);
      localStorage.setItem('password', password);
    } else {
      localStorage.removeItem('username');
      localStorage.removeItem('password');
    }
  };
  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSavedUsernameFocus = () => {
    addFocus(document.getElementById("username-span"));
    revertBorderColor(document.getElementById("div-username"));
  }

  const handleSavedPasswordFocus = () => {
    addFocus(document.getElementById("password-span"));
    revertBorderColor(document.getElementById("div-password"));
  }

  const handleUsernameFocus = () => {
    changeBorderColor(document.getElementById("div-username"));
    changeColor(document.getElementById("username-span"));
    addFocus(document.getElementById("username-span"));
  }

  const handleUsernameBlur = () => {
    if (username.length !== 0) {
      handleSavedUsernameFocus();
      revertColor(document.getElementById("username-span"));
      return;
    }
    revertBorderColor(document.getElementById("div-username"));
    revertColor(document.getElementById("username-span"));
    removeFocus(document.getElementById("username-span"));
  }

  const handlePasswordFocus = () => {
    changeBorderColor(document.getElementById("div-password"));
    changeColor(document.getElementById("password-span"));
    addFocus(document.getElementById("password-span"));
  }

  const handlePasswordBlur = () => {
    if (password.length !== 0) {
      handleSavedPasswordFocus();
      revertColor(document.getElementById("password-span"));
      return;
    }
    revertBorderColor(document.getElementById("div-password"));
    revertColor(document.getElementById("password-span"));
    removeFocus(document.getElementById("password-span"));
  }

  const addFocus = (element) => {
    element.style.transform = 'translate(14px, -12px) scale(0.75)';
    element.style.backgroundColor = 'white';
    element.style.paddingLeft = '10px';
    element.style.paddingRight = '10px';
  }

  const removeFocus = (element) => {
    element.style.transform = '';
    element.style.backgroundColor = '';
    element.style.paddingLeft = '';
    element.style.paddingRight = '';
  }

  const changeColor = (element) => {
    element.style.color = 'rgba(33, 28, 23, 1)';
  }

  const revertColor = (element) => {
    element.style.color = '';
  }

  const changeBorderColor = (element) => {
    element.style.borderColor = 'rgba(33, 28, 23, 1)';
  }

  const revertBorderColor = (element) => {
    element.style.borderColor = '';
  }

  const gatewayBaseUrl = process.env.REACT_APP_BASE_URL;
  const login = () => {
    if (username === null || username === undefined || username.length === 0) {
      document.getElementById("login-alert").style.opacity = 1;
      document.getElementById("login-msg-result").textContent = 'Please fill your username';
      return;
    }

    if (password === null || password === undefined || password.length === 0) {
      document.getElementById("login-alert").style.opacity = 1;
      document.getElementById("login-msg-result").textContent = 'Please fill your password';
      return;
    }

    document.getElementById("login-alert").style.opacity = 0;
    document.getElementById("login-msg-result").textContent = '';
    const loggingIn = async () => {
      try {
        const loginResult = await apiSender.login(username, password);
        if (!loginResult.success) {
          document.getElementById("login-alert").style.opacity = 1;
          document.getElementById("login-msg-result").textContent = loginResult.message;
          localStorage.removeItem('token');
          localStorage.removeItem('expiration');
          return;
        }
        localStorage.setItem('token', loginResult.token);
        localStorage.setItem('expiration', loginResult.expiration);
        updateLoggedIn(true);
        navigate('/dashboard');
      }
      catch (error) {
      }
    }
    loggingIn();
  }

  return (
    <div className="login">
      <div className="login-stage">
        <div className="login-card">
          <svg className="login-mark" viewBox="0 0 48 48" aria-hidden="true">
            <g fill="none" stroke="currentColor" strokeWidth="1.4">
              <circle cx="24" cy="24" r="3.4" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(45 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(90 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(135 24 24)" />
            </g>
          </svg>
          <div className="login-wordmark">AL&middot;HORIZON</div>
          <div className="login-sub">Customer Care</div>

          <div className='content-login-form'>
            <div id='div-username' className='cc-field div-username'>
              <span id='username-span'>Username</span>
              <div className='cc-field-input username-input'>
                <input type="text" value={username} autoComplete="off" placeholder=" " required onChange={handleUsernameChange} onFocus={handleUsernameFocus} onBlur={handleUsernameBlur} />
              </div>
            </div>
            <div id='div-password' className='cc-field div-password'>
              <span id='password-span'>Password</span>
              <div className='cc-field-input password-input'>
                <input id="passwordInput" value={password} type={passwordVisible ? "text" : "password"} autoComplete="off" placeholder=" " required onChange={handlePasswordChange} onFocus={handlePasswordFocus} onBlur={handlePasswordBlur} />
                <div className="eye-container">
                  <button id="togglePassword" type="button" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={handlePasswordMasking}>
                    <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} className="eye-icon" />
                  </button>
                </div>
              </div>
            </div>
            <div className="remember-me-container">
              <input id="rememberMeCheckbox" type="checkbox" checked={rememberMe} onChange={handleRememberMe} />
              <label htmlFor="rememberMeCheckbox">Remember me</label>
            </div>
            <button className="cc-btn cc-btn-primary" onClick={login}>Sign in</button>
            <div id='login-alert' className='alert'>
              <div className='left-alert'>
                <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
              </div>
              <div className='right-alert'>
                <span id="login-msg-result" className='message'></span>
              </div>
            </div>
          </div>

          <div className="login-foot">Authorised support agents only</div>
        </div>
      </div>
    </div>
  );

}
export default LoginPage;